module.exports = __webpack_public_path__ + "static/media/camera-M.inline.4a71da2d.svg";